import { FORGOT_PASSWORD_STEPS } from "./constants";

const ramos_nombres = {
    1: "incendio",
    2: "combinado familiar",
    3: "motovehiculos",
    4: "automotores",
    5: "cristales vidrios y espejos",
    6: "robo y riesgos similares",
    7: "responsabilidad civil",
    9: "granizo",
    11: "caucion",
    12: "accidentes personales",
    17: "transportes - casco",
    18: "transporte terrestre de mercaderias",
    89: "seguro colectivo de vida obligatorio",
};

const tipos_filtros = {};

export const GENERAL = "GENERAL";
export const SEGUROS = "SEGUROS";
export const PAGOS = "PAGOS";
export const CUOTAS = "CUOTAS";
export const RIESGOS = "RIESGOS";
export const DETALLE_VEHICULO = "DETALLE_VEHICULO";
export const DETALLE_MODELOREFERENCIA = "DETALLE_MODELOREFERENCIA";
export const DETALLE_ACCESORIOS = "DETALLE_ACCESORIOS";
export const DETALLE_RIESGO = "DETALLE_RIESGO";
export const LOGIN = "LOGIN";
export const LOGIN_INVALID_CREDENTIALS = "LOGIN_INVALID_CREDENTIALS";
export const OLVIDO_CONTRASEÑA = "OLVIDO_CONTRASEÑA";

const baseErrorMsj = "Se produjo un error al consultar";

const INVALID = "INVALID";
const INVALID_CUIT = "INVALID_CUIT";
const ERROR_500 = "500";

const EMAIL_FORM_STEP_INVALID = "EMAIL_FORM_STEP_INVALID";
const EMAIL_FORM_STEP_INVALID_CUIT = "EMAIL_FORM_STEP_INVALID_CUIT";
const VERIFICATION_CODE_FORM_STEP_INVALID =
    "VERIFICATION_CODE_FORM_STEP_INVALID";
const NEW_PASSWORD_FORM_STEP_INVALID = "NEW_PASSWORD_FORM_STEP_INVALID";

const EMAIL_FORM_STEP_500 = "EMAIL_FORM_STEP_500";
const VERIFICATION_CODE_FORM_STEP_500 = "VERIFICATION_CODE_FORM_STEP_500";
const NEW_PASSWORD_FORM_STEP_500 = "NEW_PASSWORD_FORM_STEP_500";

const mensajes_error = {
    [GENERAL]: `${baseErrorMsj} los datos`,

    [SEGUROS]: `${baseErrorMsj} los seguros`,
    [PAGOS]: `${baseErrorMsj} los pagos de la póliza`,
    [CUOTAS]: `${baseErrorMsj} el detalle de las cuotas`,
    [RIESGOS]: `${baseErrorMsj} los riesgos`,
    [DETALLE_VEHICULO]: `${baseErrorMsj} el detalle del vehiculo`,
    [DETALLE_MODELOREFERENCIA]: `${baseErrorMsj} los datos del modelo`,
    [DETALLE_ACCESORIOS]: `${baseErrorMsj} los accesorios del vehiculo`,
    [DETALLE_RIESGO]: `${baseErrorMsj} el riesgo asegurado`,
    [LOGIN_INVALID_CREDENTIALS]: `Usuario o contraseña incorrecta`,
    [LOGIN]: `Se produjo un error al Iniciar sesión. Inténtelo nuevamente`,

    [EMAIL_FORM_STEP_INVALID]: `El email ingresado no corresponde a un usuario registrado`,
    [EMAIL_FORM_STEP_INVALID_CUIT]: `El cuit ingresado no corresponde a un usuario registrado`,
    [VERIFICATION_CODE_FORM_STEP_INVALID]: `El código ingresado es incorrecto`,
    [NEW_PASSWORD_FORM_STEP_INVALID]: `Las contraseñas son incorrectas`,

    [EMAIL_FORM_STEP_500]: `Se produjo un error al enviar el código. Inténtelo nuevamente`,
    [VERIFICATION_CODE_FORM_STEP_500]: `Se produjo un error al validar el código. Inténtelo nuevamente`,
    [NEW_PASSWORD_FORM_STEP_500]: `Se produjo un error al resetear la contraseña. Inténtelo nuevamente`,
};

export { INVALID, INVALID_CUIT, ERROR_500, ramos_nombres, mensajes_error };
